import {
  RUSH_HOURS,
  RUSH_DAY,
  MIN_CART_VALUE_FOR_FREE_DELIVERY,
  BASE_DELIVERY_FEE,
  BASE_DELIVERY_DISTANCE,
  ADDITIONAL_DISTANCE_STEP,
  ADDITIONAL_DISTANCE_FEE,
  EXTRA_ITEMS_THRESHOLD,
  EXTRA_ITEM_FEE,
  FREE_DELIVERY_CART_VALUE,
  MAX_DELIVERY_FEE,
  RUSH_HOUR_MULTIPLIER,
  MIN_TIME,
  MAX_TIME,
} from "../constants/cons";

export const dateComparator = (a: Date, b: Date): number => {
  return a.getTime() - b.getTime();
};

export const validateOrderTime = (orderTime: string): void => {
  const orderDate = new Date(orderTime);

  if (isNaN(orderDate.getTime())) {
    throw new Error("Invalid order time");
  }

  if (dateComparator(orderDate, MIN_TIME) < 0 || dateComparator(orderDate, MAX_TIME) > 0) {
    throw new Error("Order time is out of the valid range");
  }
};

export const calculateDeliveryPrice = (
  cartValue: number = 0,
  deliveryDistance: number = 0,
  itemsCount: number = 0,
  orderTime: string
): number => {
  console.log(cartValue, deliveryDistance, itemsCount, orderTime);

  let fee = 0;

  if (cartValue < MIN_CART_VALUE_FOR_FREE_DELIVERY) {
    fee += MIN_CART_VALUE_FOR_FREE_DELIVERY - cartValue;
  }

  if (deliveryDistance > BASE_DELIVERY_DISTANCE) {
    fee +=
      BASE_DELIVERY_FEE +
      Math.ceil((deliveryDistance - BASE_DELIVERY_DISTANCE) / ADDITIONAL_DISTANCE_STEP) *
        ADDITIONAL_DISTANCE_FEE;
  } else {
    fee += BASE_DELIVERY_FEE;
  }

  if (itemsCount > EXTRA_ITEMS_THRESHOLD) {
    fee += (itemsCount - EXTRA_ITEMS_THRESHOLD) * EXTRA_ITEM_FEE;
  }

  const orderDate = new Date(orderTime);
  const orderHour = orderDate.getHours();
  const orderDay = orderDate.getDay();

  if (RUSH_HOURS.includes(orderHour) && orderDay === RUSH_DAY) {
    fee *= RUSH_HOUR_MULTIPLIER;
  }

  if (cartValue >= FREE_DELIVERY_CART_VALUE) {
    fee = 0;
  }

  return Math.min(fee, MAX_DELIVERY_FEE);
};
